import React, { useReducer } from "react";
import axios from "axios";
import MainContext from "./mainContext";
import MainReducer from "./mainReducer";
import { SET_STUDENT_DATA } from "../types";
import getGradDate from "../../helpers/getGradDate";

const MainState = (props) => {
  const initialState = {
    iframe: false,
    studentData: {},
    formData: {
      credits: null,
      school: "",
      age: null,
      firstName: "",
      lastName: "",
      zipCode: null,
      email: "",
      phone: "",
    }
  };

  const [state, dispatch] = useReducer(MainReducer, initialState);

  const onChange = (e) => {
    dispatch({type: 'ON_CHANGE', name: e.target.name, value: e.target.value})
  }

  const onIframe = () => {
    dispatch({type: 'IFRAME'})
  }

  const sendData = async (data) => {
    const headers = {
      headers: {
        'Content-Type':'application/json'
      }
    }
    try {
      const res = await axios.post('https://graduationtracker.azurewebsites.net/api/sql/', data, headers)
    // const res = await axios.post('http://localhost:5000/api/sql/', data, headers)
    console.log(res.data)
    } catch (err) {
      console.error(err.message)
    }
    
  }
  const emailData = async (data) => {
    const headers = {
      headers: {
        'Content-Type':'application/json'
      }
    }
    try {
      const res = await axios.post('https://graduationtracker.azurewebsites.net/api/email/', data, headers)
    // const res = await axios.post('http://localhost:5000/api/email/', data, headers)
    console.log(res.data)
    } catch (err) {
      console.error(err.message)
    }

  }

  const setStudentData = (data) => {
    const {
      credits,
      school,
      age,
      firstName,
      lastName,
      zipCode,
      email,
      phone,
    } = data;
    const { date1, date2 } = getGradDate(credits);
    const newStudentData = {
      credits,
      school,
      age,
      firstName,
      lastName,
      zipCode,
      email,
      phone,
      date1,
      date2,
    };
    sendData(newStudentData)
    email ? emailData(newStudentData) : console.log('no email')
    dispatch({ type: SET_STUDENT_DATA, payload: newStudentData });
  };

  return (
    <MainContext.Provider
      value={{
        studentData: state.studentData,
        formData: state.formData,
        iframe: state.iframe,
        setStudentData,
        onChange,
        onIframe
      }}
    >
      {props.children}
    </MainContext.Provider>
  );
};

export default MainState;
